import "./App.css";
import { useState, useEffect } from "react";
import env from "react-dotenv";
import Footer from "./containers/Footer";
import Navbar from "./containers/Navbar";

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const info = {
    title: "Hints for Bamboozled",
    org: "The Editorial Board, JSSSTU",
    loading: "Please wait...",
  };

  useEffect(() => {
    fetch(env.REACT_APP_LINKS_DATA, {
      cache: "reload"
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`
          );
        }
        return response.json();
      })
      .then((actualData) => {
        setData(actualData);
        setError(null);
      })
      .catch((err) => {
        setError(err.message);
        setData(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="App">
      <Navbar info={info} />
      <div className="container-fluid main">
        <div className="row d-flex justify-content-center">
          <div className="col-md-6 d-flex justify-content-center py-5">
            <div className="card shadow">
              <ul className="list-group list-group-flush">
                {loading && (
                  <div className="text-center p-3">{info.loading}</div>
                )}
                {error && (
                  <div className="p-3">{`There is a problem fetching the post data - ${error}`}</div>
                )}
                {data &&
                  data.map(({ level, clue, textcolor, bgcolor }) => (
                    <li
                      className={`list-group-item p-3 bg-${bgcolor} text-${textcolor}`}
                      key={level}
                    >
                      <span className="fw-bold">{level}</span>: {clue}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
